import React from "react";
import { SOPORTE_TEMA } from "../Chat/fasesSoporte";

export const ESTILOS_REPORTE = `
  @keyframes repFadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .rep-root {
    background: #ffffff;
    border-radius: 20px;
    padding: 24px 24px 32px;
  }

  /* ── Cards de gráfica ── */
  .rep-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 20px 22px 18px;
    /* Alto automático: aquí las gráficas crecen con los datos y una card
       lleva además una tabla debajo. */
    height: 100%;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.04);
    opacity: 0;
    animation: repFadeUp 0.55s cubic-bezier(0.22,1,0.36,1) both;
    transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.2s ease;
  }
  .rep-card:hover {
    border-color: rgba(250,140,22,0.35);
    box-shadow: 0 4px 24px rgba(250,140,22,0.1), 0 1px 6px rgba(0,0,0,0.06);
    transform: translateY(-2px);
  }

  .rep-card-head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 12px;
  }
  .rep-card-label {
    font-size: 9.5px;
    font-weight: 800;
    letter-spacing: 0.13em;
    text-transform: uppercase;
    color: ${SOPORTE_TEMA.primario};
    margin-bottom: 2px;
  }
  .rep-card-title {
    font-size: 15px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    letter-spacing: -0.01em;
  }

  /* barra de color en la parte superior de cada card */
  .rep-card-accent {
    height: 3px;
    width: 40px;
    border-radius: 3px;
    background: linear-gradient(90deg, ${SOPORTE_TEMA.primario}, #ffc069);
    margin-bottom: 16px;
  }

  .rep-divider {
    height: 1px;
    background: #f1f5f9;
    margin: 16px 0 12px;
  }

  .rep-period-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #fff7e6;
    border: 1px solid #ffd591;
    color: #d46b08;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.05em;
    padding: 3px 10px;
    border-radius: 20px;
    white-space: nowrap;
    flex-shrink: 0;
  }
  .rep-pill-dot {
    width: 5px; height: 5px;
    border-radius: 50%;
    background: ${SOPORTE_TEMA.primario};
    flex-shrink: 0;
  }

  @media (max-width: 767px) {
    .rep-root {
      padding: 16px 12px 24px;
      border-radius: 14px;
    }
    .rep-card {
      padding: 14px 14px 12px;
      border-radius: 12px;
    }
    .rep-card-accent { margin-bottom: 10px; }
    .rep-card-head { margin-bottom: 8px; }
  }
`;

export const NIVO_TEMA_SOPORTE = {
  background: "transparent",
  fontSize: 11,
  text: { fill: "#94a3b8", fontSize: 11 },
  grid: { line: { stroke: "#f1f5f9", strokeWidth: 1 } },
  axis: { ticks: { text: { fill: "#94a3b8", fontSize: 10.5 } } },
  legends: { text: { fill: "#64748b", fontSize: 11 } },
  tooltip: {
    container: {
      background: "#ffffff",
      color: "#1e293b",
      border: "1px solid #e2e8f0",
      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
      borderRadius: 10,
      fontSize: 12,
    },
  },
};

export const CARD_KPI_STYLE = {
  borderRadius: 14,
  border: "1px solid #e2e8f0",
  boxShadow: "0 1px 4px rgba(0,0,0,0.05), 0 4px 16px rgba(0,0,0,0.04)",
  overflow: "hidden",
};


export const CardGrafica = ({ etiqueta, titulo, pill, accent, alto, delay, footer, children }) => (
  <div className="rep-card" style={delay ? { animationDelay: delay } : undefined}>
    <div className="rep-card-head">
      <div>
        {etiqueta && <div className="rep-card-label">{etiqueta}</div>}
        <h2 className="rep-card-title">{titulo}</h2>
      </div>
      {pill && (
        <span className="rep-period-pill">
          <span className="rep-pill-dot" />
          {pill}
        </span>
      )}
    </div>
    <div className="rep-card-accent" style={accent ? { background: accent } : undefined} />
    {alto ? <div style={{ height: alto }}>{children}</div> : children}
    {footer && (
      <>
        <div className="rep-divider" />
        {footer}
      </>
    )}
  </div>
);

export const ACENTOS = {
  naranja: `linear-gradient(90deg, ${SOPORTE_TEMA.primario}, #ffc069)`,
  lila: "linear-gradient(90deg, #5e4276, #9d7fbb)",
  verde: "linear-gradient(90deg, #24ad44, #6fd98a)",
  mostaza: "linear-gradient(90deg, #f5d107, #ffe985)",
  azul: "linear-gradient(90deg, #1890ff, #69c0ff)",
};
